/* eslint-disable no-unused-vars */
export enum RoutePath {
  ALL = '/*',
  FORGOT_PASSWORD = '/forgot-password',
  LOGIN = '/login',
  NOT_FOUND = '/not-found',
  RESET_PASSWORD = '/reset-password',
  REGISTER = '/register',
  PAYMENT = '/payment',
  AGENCY = '/agency',
  EMPTY = '/',
  ACCOUNT = '/accounts',
  EDIT = '/edit',
  ID = '/:id',
  REPAIR_ID = '/:repairId',
  DOCUMENT_ID = '/:documentId',
  REPAIR_PATH = '/repairs',
  INSURANCE_APPLICATION = '/submit-agreement',
  REQUEST = '/request',
  HASH_CODE = '/:hashCode',
  CUSTOMERS = '/customers',
  CLIENTS = '/clients',
  DOCUMENT_VIEWER = '/document-viewer',
  PERSONAL_INFO = '/personal-info',
  ADMIN = '/admin',
  CUSTOMER = '/customer',
  REPAIRS = '/admin/repairs',
  REPAIRS_CREATE = '/admin/repairs/create',
  REPAIRS_EDIT = '/admin/repairs/:id/edit',
  REPAIRS_DETAIL = '/admin/repairs/:id',
  MAKERS = '/makers',
  PRODUCTS = '/products',
  MODELS = '/models',
  CUSTOMER_HISTORY = '/customer-history',
  CONFIG = '/config',
  EXPIRATION = '/expiration',
  SUCCESS = '/success',
  DETAIL = '/detail',
  IMEI = '/imei',
  HISTORY_DETAIL = '/history-detail',
  PLANS = '/plans',
  PLAN_CREATE = '/plans/create',
  PLAN_EDIT = '/plans/:id/edit',
  PLAN_DETAIL = '/plans/:id',
  SUBSCRIPTIONS = '/subscriptions',
  SUBSCRIPTIONS_DETAIL = '/subscriptions/:id',
  PAYMENTS = '/payments',
  AGENCY_EDIT = '/agency/:id/edit',
  AGENCY_AUTHORITY = '/agency-authority',
  DOCUMENT_VIEW = '/document-view/:id',
  QR_CODE = '/qr-codes',
  SALES = '/sales',
  DASHBOARD = '/dashboard',
  CREATE = '/create',
  COUNT_SETTING_NUMBER = '/count-setting-number'
}

export enum ScreenType {
  CREATE = 'create',
  EDIT = 'edit',
  DETAIL = 'detail'
}
